// Typelizer digest c599c46c5bd579e111263724978115ec
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /pivots */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/pivots', {}, options),
    method: 'post',
  }),

  /** GET /pivots/new */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/pivots/new', {}, options),
    method: 'get',
  }),

  /** GET /pivots/:id/edit */
  edit: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/pivots/:id/edit', params, options),
    method: 'get',
  }),

  /** GET /pivots/:id */
  show: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/pivots/:id', params, options),
    method: 'get',
  }),

  /** PATCH /pivots/:id */
  update: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/pivots/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /pivots/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/pivots/:id', params, options),
    method: 'delete',
  }),
}
